const DEFAULT_PAGE_SIZE = 50;

/**
 * Page size for the sessions side panel. Smaller than the table's page — the
 * panel is a narrow drill-down preview, and anything past this is reached via
 * its expand action rather than by scrolling a side column.
 */
const SESSIONS_PANEL_PAGE_SIZE = 25;

/**
 * The FULL set of Model Comparison / Usage-only URL params, stripped whenever
 * navigation lands on the **Sessions** view — the one tab that ignores every
 * one of them (tab switch to Sessions, drill-down "expand to Sessions", and
 * filter Reset). Otherwise a stray param lingers in a Sessions URL and silently
 * reactivates on return. Kept in one place so every "go to Sessions" path
 * strips the identical set (the paths used to diverge; see BFK-2060 review).
 * `session` and `model_family` are excluded: they are shared Sessions params
 * each caller handles explicitly.
 */
const MODEL_COMPARISON_URL_PARAMS = [
  'view',
  'cycle_view',
  'usage_view',
  'measure',
  'model_provider',
  'hidden_families',
  'model_show_unknown',
  'allocation',
  'sessions_family',
  'sessions_start',
  'sessions_end',
  'taskfit_dimension',
  'taskfit_model_provider',
  'taskfit_hidden_families',
  'taskfit_show_unknown',
  'taskfit_metric',
  'taskfit_cell_row',
  'taskfit_cell_family',
] as const;

/**
 * The SUBSET dropped when switching between two AI-adoption tabs (e.g. Model
 * Comparison → Delivery Impact). Only params local to one specific view or to
 * an open drill-down are cleared; `view/allocation/model_provider/hidden_families`
 * are intentionally shared across the AI-adoption tabs, so they survive the
 * switch and Model Comparison re-opens with the user's configuration intact.
 */
const MODEL_COMPARISON_TAB_LOCAL_PARAMS = [
  'measure',
  'usage_view',
  'sessions_family',
  'sessions_start',
  'sessions_end',
  'taskfit_dimension',
  'taskfit_model_provider',
  'taskfit_hidden_families',
  'taskfit_show_unknown',
  'taskfit_metric',
  'taskfit_cell_row',
  'taskfit_cell_family',
] as const;

/**
 * Adoption-only URL params, dropped on EVERY tab switch (mirroring the inline
 * `di_*` deletions in handleSelectTab) and by the tab's filter Reset. Kept in
 * one constant so the two paths can't drift apart (the BFK-2060 class of bug).
 */
const ADOPTION_TAB_LOCAL_PARAMS = ['ad_view', 'ad_measure', 'ad_teams'] as const;

export {
  ADOPTION_TAB_LOCAL_PARAMS,
  DEFAULT_PAGE_SIZE,
  MODEL_COMPARISON_TAB_LOCAL_PARAMS,
  MODEL_COMPARISON_URL_PARAMS,
  SESSIONS_PANEL_PAGE_SIZE,
};
